import Api from '../../../Services/Api';

/**
 * Service to fetch Facebook accounts from backend configuration
 */
export const facebookAccountService = {
  /**
   * Get all Facebook accounts configured in the backend
   * @param {string} feature - Optional: 'launcher', 'analytics', or 'all'
   * @returns {Promise<Array>} Array of Facebook accounts
   */
  async getAccounts(feature = 'all') {
    try {
      const response = await Api.getFacebookAccounts(feature);
      
      if (response.data && response.data.success) {
        return response.data.accounts || [];
      }
      
      return [];
    } catch (error) {
      console.error('Error fetching Facebook accounts:', error);
      return [];
    }
  },

  /**
   * Get accounts for analytics feature
   * @returns {Promise<Array>} Array of Facebook accounts enabled for analytics
   */
  async getAnalyticsAccounts() {
    return this.getAccounts('analytics');
  },

  /**
   * Get accounts for launcher feature
   * @returns {Promise<Array>} Array of Facebook accounts enabled for launcher
   */
  async getLauncherAccounts() {
    return this.getAccounts('launcher');
  }
};